var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopy(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "feather",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 15H6C3.79086 15 2 13.2091 2 11V6C2 3.79086 3.79086 2 6 2H11C13.2091 2 15 3.79086 15 6V8.5M13 22H18C20.2091 22 22 20.2091 22 18V13C22 10.7909 20.2091 9 18 9H13C10.7909 9 9 10.7909 9 13V18C9 20.2091 10.7909 22 13 22Z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.0a5bbcd9.svg";
export { ForwardRef as ReactComponent };